var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-timeline"},[_c('b-img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.timelineImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }